module.exports = __webpack_public_path__ + "img/fashion_38.aab3a9b4.jpg";